export default __webpack_public_path__ + "static/media/Knife of the Crawling Chaos.c7168b5e.jpg";